import css from "./NotificationDetails.module.css";
import Head from "../../../Components/Head/Head";
import Url from "../../../Services/Url";
import { PublicGet } from "../../../Services/Server";
import { useState, useEffect } from "react";
import User from "../../../Services/User";
import { useParams } from "react-router-dom";
import Milestones from "../../../Components/Milestones2/Milestones";
import { setNav } from "../../../Components/NavMenu/ClientNavMenu";

const NotificationDetails = () => {
	const [data, setData] = useState(null);
	const [taskMilestones, setMilestones] = useState([]);

	const company = User.getCompany();
	const companyId = company.id;
	const trackingCode = company.companyTrackingCode || "";
	const isEnt = trackingCode.toLowerCase().startsWith("ent");

	const { id } = useParams();

	useEffect(() => {
		//  Fetch notification details
		PublicGet(Url.getCompanyNotification(id, companyId, isEnt))
			.then((resp) => {

				// Flatten milestones list from all task equipment
				const ms = resp.task.taskEquipmentList.reduce((acc, equipment) => {
					equipment.taskMilestones.forEach((m) => (m.equipment = equipment.name));
					return [...acc, ...equipment.taskMilestones];
				}, []);

				setMilestones(ms);
				setData(resp);

				//  Update unread notification count
				PublicGet(Url.countCompanyNotifications(companyId, isEnt, false)).then(
					(cnt) => {
						setNav.notification(cnt);
					}
				);
			})
			.catch((err) => {
				console.error("Error fetching notification details:", err);
			});
	}, [id, companyId, isEnt]);

	return (
		<div className={css.page}>
			{data && (
				<>
					<div className={css.Left}>
						<Head title={data.notification.title} dropdown={[]} />
						{data.notification.details && (
							<div className={css.msg}>{data.notification.details}</div>
						)}

						<div className={css.details}>
							<div>
								<div>Notification From</div>
								<div>
									{data.notification.staff.firstname}{" "}
									{data.notification.staff.lastname}
								</div>
							</div>
							<div>
								<div>Created At</div>
								<div>
									{new Date(data.notification.createdAt).toUTCString()}
								</div>
							</div>
							<div>
								<div>From Task</div>
								<div>{data.task.title}</div>
							</div>
							<div>
								<div>Job Number</div>
								<div>{data.task.jobNumber}</div>
							</div>
							<div>
								<div>Tracking Number</div>
								<div>{data.task.tracking}</div>
							</div>
						</div>
					</div>

					<div className={css.Right}>
						<Milestones>{taskMilestones}</Milestones>
					</div>
				</>
			)}
		</div>
	);
};

export default NotificationDetails;
